<template>
  <div>
    <SimpleFieldList
      :disabled="disabled"
      :operators="operators"
      :spr="tenderStatuses"
      :value.sync="mutableValue"/>
  </div>
</template>
<script>
import SimpleFieldList from 'components/automation/conditions/default/simpleFieldList.vue'
/**
 * 8
 */
export default {
  name: 'tenderCurrency',
  computed: {
    tenderStatuses() {
      return this.$store.getters.getCurrencies.map(i => ({
        key: i.code,
        label: i.shortTitle,
        description: i.title
      }))
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldList
  },
  async created() {
    await this.$store.dispatch('setCurrencies')
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
